module.exports = __webpack_public_path__ + "static/media/digital-shop.cd7baec9.jpg";